/**
 * Displayed at the top when there are no strengths indicated.
 */
import React, { PropTypes } from 'react';

function ResultNoStrengths({ text, title }) {
  return (
    <span>
      <div>
        <h2>
          {title}
        </h2>
        <div
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </div>
    </span>
  );
}

ResultNoStrengths.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
};

export default ResultNoStrengths;



// WEBPACK FOOTER //
// js/src/assessment/ResultNoStrengths.js